import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageFromYoutube from '../../transforms/ImageFromYoutube';

class VideoList extends Component {
  constructor(props) {
    super(props);

    const list = props.list.map(v => ({
      url: v.url,
    }));

    this.state = {
      list,
      edit: false,
      index: undefined,
      error: undefined,
      showForm: false,
      url: '',
    };

    this.props.onChange(list);
  }

  addItem = (e) => {
    e.preventDefault();
    const { list } = this.state;

    if (!this.state.url) {
      this.setState({ error: 'Debe ingresar la URL del video' });
      return;
    }

    const obj = {
      url: this.state.url,
    };

    if (this.state.edit === false) {
      list.push(obj);
    } else {
      list[this.state.index] = obj;
    }

    this.setState({
      list,
      edit: false,
      index: undefined,
      error: undefined,
      url: '',
    }, () => {
      this.props.onChange(this.state.list);
    });
  };

  removeItem = (e, i) => {
    e.preventDefault();
    const { list } = this.state;
    const index = list.indexOf(i);
    if (index > -1) {
      list.splice(index, 1);
    }

    this.setState({
      list,
    }, () => {
      this.props.onChange(this.state.list);
    });
  };

  showForm = (e) => {
    e.preventDefault();
    this.setState({ showForm: true });
  };

  hideForm = (e) => {
    e.preventDefault();
    this.setState({ showForm: false });
  };

  getVideoCss = () => {
    const img = ImageFromYoutube(this.state.url);
    if (!img) { return {}; }

    return { backgroundImage: `url(${img})` };
  };

  render() {
    const { showForm } = this.state;
    return (
      <Fragment>
        <div className={`achievements__wrapper ${showForm ? 'active' : ''}`}>
          {this.props.title && (
            <h2 className="heading">{this.props.title}</h2>
          )}
          <div className="form-group achievements" style={{ display: this.state.showForm ? 'flex' : 'none' }}>
            <div className="achievements__error">{this.state.error}</div>
            <div className="achievements__title">
              <label>URL</label>
              <div className="video-list__input-wrapper">
                <input autoComplete="off" type="text" name="url" value={this.state.url} className="input-text" onChange={e => this.setState({ url: e.target.value })} />
                <div className="video-list__preview" style={this.getVideoCss()} />
              </div>
            </div>
            <div className="achievements__add">
              <button className="btn-add" onClick={this.addItem}>
                {this.state.edit ? 'Editar' : 'Añadir'}
              </button>
              <button className="btn-cancel" onClick={this.hideForm}>
                Terminar
              </button>
            </div>
          </div>
          <div className="video-list__content">
            <ul className="achievements__list row">
              {this.state.list.length === 0 && (
              <p className="achievements__not-added">{this.props.notAddedYet}</p>
            )}
              {this.state.list.map(i => (
                <div className="col-lg-3 col-md-4 col-xs-6" key={i.url}>
                  <div className="d-block mb-4 h-100 current-image-item">
                    <img
                      className="img-fluid img-thumbnail"
                      src={ImageFromYoutube(i.url)}
                      alt=""
                    />
                    <button
                      onClick={(e) => this.removeItem(e, i)}
                      className="delete-image-span"
                    >
                      <i className="fa fa-trash" />
                    </button>
                  </div>
                </div>
            ))}
            </ul>
          </div>
          <button className="achievements__add-button" onClick={this.showForm} style={{ display: this.state.showForm ? 'none' : 'block' }}>
            <i className="fa fa-plus" aria-hidden="true" /> Añadir video
          </button>
        </div>
      </Fragment>
    );
  }
}

VideoList.propTypes = {
  title: PropTypes.string,
  onChange: PropTypes.func,
  notAddedYet: PropTypes.string,
};

VideoList.defaultProps = {
  title: undefined,
  onChange: () => {},
  notAddedYet: 'Aún no has añadido videos',
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/VideoList/index.js